/**
 * 创建人：李珊
 * 时间：2020-12-24
 * 描述：下拉树展示组件的筛选功能
 * 更新记录: 
 */
import { Pipe, PipeTransform } from '@angular/core';


/**
 * 用作下拉树展示的搜索栏
 */
@Pipe({
  name: 'treeSelectFilter'
})
export class TreeSelectFilterPipe implements PipeTransform {

  transform(list: any[],filterField:string,keyword:string): any {///数据源,字段名,关键字
    if(!filterField || !keyword){
        return list;
    }
    var newlist= list.filter(x=>x[filterField].indexOf(keyword)>=0);
    if(newlist.length == 0){
        return [];
    }
    let res = [];
    newlist.forEach(item => {
        res = this.getParents(list,item,res);
    })
    return res;
  }

  // 根据当前项获取所有父级
  getParents(list,item,parents){
    if(parents.indexOf(item) == -1){
      parents.push(item);
    }
    let parentNode = list.filter(el => el.id == item.pid);
    if(parentNode.length == 0){
      return parents
    }else{
      return this.getParents(list,parentNode[0],parents);
    }
  }
}
